import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  InitAiChatMutation,
  InitAiChatMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const initAiChatQuery = graphql(`
  mutation initAiChat($req: AiChatStreamRequest!) {
    initAiChat(AiChatStreamRequest: $req) {
      conversationId
      question
    }
  }
`);

export type AiChatQuestion = InitAiChatMutation["initAiChat"];
export function useInitAiChat(
  options?: UseMutationOptions<InitAiChatMutation, unknown, InitAiChatMutationVariables, unknown>,
) {
  return useGraphQlMutation(initAiChatQuery, { ...options });
}
